// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3125) return "static/chunks/3125-5c3fdc9e1f53859b.js";
	if (chunkId === 2112) return "static/chunks/2112-d420d5a569d54e2d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4351 ? "container-query" : chunkId) + "." + {"764":"4b417bb3cbfe48e5","1966":"05e4e655ebd604df","3899":"dc809c58d36984d6","4351":"28c3c016f14c5f4f"}[chunkId] + ".js";
};